import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QuestionPublic, api } from "../lib/api";
import QuestionCard from "../components/QuestionCard";

export default function Practice() {
  const { certId } = useParams<{ certId: string }>();
  const [questions, setQuestions] = useState<QuestionPublic[]>([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!certId) return;
    api.practiceQuestions(certId, undefined, 10).then(setQuestions);
  }, [certId]);

  if (!certId) return <p>Certification inconnue.</p>;
  if (questions.length === 0) return <p>Chargement…</p>;
  if (idx >= questions.length) {
    return (
      <div className="card max-w-md mx-auto text-center">
        <h2 className="font-display text-2xl mb-4">Session terminée.</h2>
        <button onClick={() => { setIdx(0); api.practiceQuestions(certId).then(setQuestions); }} className="btn-primary">
          Nouvelle session
        </button>
      </div>
    );
  }

  return (
    <div>
      <p className="text-xs font-mono text-scribe-600 mb-4">
        Question {idx + 1} / {questions.length}
      </p>
      <QuestionCard
        key={questions[idx].id}
        question={questions[idx]}
        mode="practice"
        onNext={() => setIdx(idx + 1)}
      />
    </div>
  );
}
